export default (...args) => {
  args.pop();
  return args.join('');
};